<script setup>
import { cn } from '@/lib/utils'

const props = defineProps({
  class: { type: String, default: '' },
})
</script>

<template>
  <div :class="cn('rounded-lg border border-line bg-surface text-ink shadow-xs', props.class)">
    <slot />
  </div>
</template>
